<template>
    <div class="main-body">
        <h2>Report</h2>
        <div class="filter">
            <el-form :inline="true" :model="filter" class="demo-form-inline">
                <el-form-item label="">
                    <el-select v-model="filter.app_id" size="small" class="max-width-160">
                        <el-option v-for="(item, idx) in options.apps" :key="idx" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-select v-model="filter.country" :placeholder="$strings('word/country')" size="small"
                               class="max-width-120">
                        <el-option v-for="(item, idx) in options.cts" :label="item.label" :value="item.value"
                                   :key="idx"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-date-picker
                        size="small"
                        v-model="filter.dateRange"
                        type="daterange"
                        format="MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="~"
                        class="max-width-200"
                        start-placeholder="From"
                        end-placeholder="To">
                    </el-date-picker>
                </el-form-item>
            </el-form>
        </div>
        <div class="report">
            <h4>Overview</h4>
            <el-row :gutter="16">
                <el-col :span="6">
                    <el-card shadow="never" v-loading="loadingSummary">
                        <span class="font-32">{{ this.summaryData.queue_count }}</span>&nbsp;
                        <span class="font-12 vertical-top">Queue</span>
                    </el-card>
                </el-col>
                <el-col :span="6">
                    <el-card shadow="never" v-loading="loadingSummary">
                        <span class="font-32 text-success">{{ this.summaryData.success_count }}</span>&nbsp;
                        <span class="font-12 vertical-top">Success</span>
                    </el-card>
                </el-col>
                <el-col :span="6">
                    <el-card shadow="never" v-loading="loadingSummary">
                        <span class="font-32 text-warning">{{ this.summaryData.fail_count }}</span>&nbsp;
                        <span class="font-12 vertical-top">Fail</span>
                    </el-card>
                </el-col>
                <el-col :span="6">
                    <el-card shadow="never" v-loading="loadingSummary">
                        <span class="font-32">{{ this.summaryData.charge_amount }}</span>&nbsp;
                        <span class="font-12 vertical-top">Charged</span>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <div class="send-stat">
            <h4>State</h4>
            <el-row :gutter="16">
                <el-col :span="16">
                    <el-card shadow="never" class="card-min" :body-style="{padding:'0'}">
                        <div slot="header">By Day</div>
                        <div>
                            <div ref="container" style="width: 100%;height:300px;"></div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card shadow="never" class="card-min">
                        <div slot="header">Country Share</div>
                        <div>
                            <div class="progress-row">
                                <div class="progress-item">ET</div>
                                <div class="progress-it">
                                    <el-progress :percentage="50" :format="formatCountry"></el-progress>
                                </div>
                                <div class="progress-item">100%</div>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import {DefaultDate} from "@/utils/time";
import {CpSitAppRead, CpSiteDashSummaryRead} from "@/api/cpsite/api";
import {GetItem} from "@/utils/storage";
import {CTS, STORAGE_KEY_LOGIN_TZ} from "@/config/config";
import * as echarts from 'echarts';
import "@/plugin/echart/theme-shine";
import {APP_STATUS} from "../../../config/config";

export default {
    name: "cpsite-dash",
    data() {
        return {
            loading: true,
            loadingSummary: true,
            options: {
                apps: [],
                cts: CTS,
            },
            myChart: null,
            filter: {tz: 0, dateRange: [], app_id: '', country: '', date_start: '', date_end: ''},
            summaryData: {'success_count': 0, 'fail_count': 0, 'charge_amount': 0, 'queue_count': 0},
        }
    },
    created() {
        this.prepareData();
        this.fetchSummary();
    },
    mounted() {
        this.initChart();
    },
    methods: {
        initChart() {
            this.myChart = echarts.init(this.$refs['container'], "shine");
            this.myChart.showLoading('default', {
                color: '#1890FF',
                lineWidth: 4,
                spinnerRadius: 16,
            });
            this.myChart.setOption({
                xAxis: {
                    type: 'category',
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                },
                yAxis: {
                    type: 'value'
                },
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '4%',
                    right: '4%',
                    bottom: '4%',
                    top: '10%',
                    containLabel: true
                },
                series: [
                    {
                        data: [150, 230, 224, 218, 135, 147, 260],
                        type: 'line',
                        name: 'A'
                    },
                    {
                        data: [166, 230, 224, 218, 111, 147, 310],
                        type: 'line',
                        name: 'B'
                    }
                ]
            });
            this.myChart.hideLoading();
        },
        prepareData() {
            this.filter.dateRange = [DefaultDate(-3), DefaultDate()];
            this.filter.tz = GetItem(STORAGE_KEY_LOGIN_TZ) * 1
            this.loading = true;
            CpSitAppRead({page: 1, size: 100}).then((resp) => {
                this.options.apps = [];
                if (resp.data.data.total > 0) {
                    this.options.apps.push({value: '', label: this.$strings('word/all_apps')});
                    resp.data.data.rows.forEach((item) => {
                        if (item.app_status === APP_STATUS.LIVING) {
                            this.options.apps.push({value: item.app_id, label: item.app_name});
                        }
                    })
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        formatCountry() {
            return ' 992';
        },
        fetchSummary() {
            this.loadingSummary = true;
            this.filter.date_start = this.filter.dateRange[0];
            this.filter.date_end = this.filter.dateRange[1];
            CpSiteDashSummaryRead(this.filter).then((resp => {
                if (resp.data) {
                    this.summaryData = resp.data.data;
                }
            })).finally(() => {
                this.loadingSummary = false;
            });
        }
    }
}
</script>
<style lang="scss">
.card-min {
    .el-card__header {
        padding: 0.8em 1em;
        font-size: 14px;
    }
}
</style>
<style scoped lang="scss">
.filter {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
}

.progress-row {
    display: flex;
    flex-direction: row;
}

.progress-it {
    flex: 5;
}

.progress-item {
    flex: 1;
    font-size: 14px;
    line-height: 20px;
}
</style>